import { Badge } from "@/components/ui/badge";
import { Team } from "@/types";
import { Users } from "lucide-react";
import { cn } from "@/lib/utils";

interface TeamBadgeProps {
    team: Team;
    className?: string;
    showIcon?: boolean;
}

export function TeamBadge({ team, className, showIcon = true }: TeamBadgeProps) {
    return (
        <Badge variant="secondary" className={cn("gap-1.5", className)}>
            {showIcon && <Users className="h-3 w-3" />}
            {team.name}
        </Badge>
    );
}
